var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBurundi({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 26,
    viewBox: "0 0 36 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_26_3490)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_26_3490",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 30,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 30,
    height: 20,
    rx: 2,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_26_3490)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.6276 3H3.66577L18.1467 11.4461L32.6276 3Z",
    fill: "#BD1F34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.66577 23H32.6276L18.1467 14.5539L3.66577 23Z",
    fill: "#BD1F34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2934 21.4461V4.55392L20.8124 13L35.2934 21.4461Z",
    fill: "#50B648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 21.4461L15.4809 13L1 4.55392V21.4461Z",
    fill: "#50B648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2934 3H32.6276L22.2994 9.02143C21.2411 7.97656 19.7743 7.33356 18.1467 7.33356C16.5191 7.33356 15.0522 7.98326 13.994 9.02143L3.66577 3H1V4.55392L12.5807 11.3121C12.4066 11.848 12.3195 12.4173 12.3195 13.0067C12.3195 13.5961 12.4133 14.1654 12.5807 14.7013L1 21.4461V23H3.66577L13.994 16.9786C15.0522 18.0234 16.5191 18.6664 18.1467 18.6664C19.7743 18.6664 21.2411 18.0167 22.2994 16.9786L32.6276 23H35.2934V21.4461L23.7127 14.6946C23.8868 14.1587 23.9739 13.5894 23.9739 13C23.9739 12.4106 23.8801 11.8413 23.7127 11.3054L35.2934 4.55392V3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5285 9.39652L18.1467 8.73343L17.7649 9.39652H16.9946L17.3764 10.0663L16.9946 10.7361H17.7649L18.1467 11.3992L18.5285 10.7361H19.2987L18.9169 10.0663L19.2987 9.39652H18.5285Z",
    fill: "#50B648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4554 14.4669L21.8439 13.7971H21.0737L20.6852 13.134L20.3034 13.7971H19.5331L19.9149 14.4669L19.5331 15.1367H20.3034L20.6852 15.7997L21.0737 15.1367H21.8439L21.4554 14.4669Z",
    fill: "#50B648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.99 13.7971L15.6082 13.134L15.2197 13.7971H14.4495L14.8379 14.4669L14.4495 15.1367H15.2197L15.6082 15.7997L15.99 15.1367H16.7602L16.3785 14.4669L16.7602 13.7971H15.99Z",
    fill: "#50B648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4615 9.51708L18.1467 8.97455L17.8319 9.51708H17.2023L17.5171 10.0663L17.2023 10.6155H17.8319L18.1467 11.1581L18.4615 10.6155H19.0911L18.7763 10.0663L19.0911 9.51708H18.4615Z",
    fill: "#BD1F34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3215 14.4669L21.6363 13.9176H21L20.6852 13.3751L20.3704 13.9176H19.7408L20.0556 14.4669L19.7408 15.0161H20.3704L20.6852 15.5586L21 15.0161H21.6363L21.3215 14.4669Z",
    fill: "#BD1F34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.923 13.9176L15.6081 13.3751L15.2866 13.9176H14.657L14.9718 14.4669L14.657 15.0161H15.2866L15.6081 15.5586L15.923 15.0161H16.5526L16.2378 14.4669L16.5526 13.9176H15.923Z",
    fill: "#BD1F34"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_26_3490",
    x: 0,
    y: 0,
    width: 36,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_26_3490"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_26_3490",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurundi);
export default __webpack_public_path__ + "static/media/Burundi.701c99f8062c3599df89634d8ed5c282.svg";
export { ForwardRef as ReactComponent };